import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoMassTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoMassTypeModel._instance == null) GeoMassTypeModel._instance = new GeoMassTypeModel(authManager);
        return GeoMassTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/geo-mass-types', 'geo-sections/geo-mass-types/codelist');

        this.entityName = 'geo-sections.GeoMassType';
        this.privileges = {
            create: [["adminSystem"]],
            read: [["#everyone"]],
            update: [["adminSystem"]],
            delete: [["adminSystem"]],
        };

        this.label = 'Mass Type';
        this.setLabel = 'Mass Types';

        this.browser = {
            name: 'default-geo-sections-geomasstype-browser',
            moduleName: 'default-geo-sections-geomasstype-browser',
            moduleTitle: 'Mass Types',
            moduleStateSlotName: 'default-geo-sections-geomasstype-browser',
        };

        this.editor = {
            name: 'default-geo-sections-geomasstype-editor',
            moduleName: 'default-geo-sections-geomasstype-editor',
            moduleTitle: 'Mass Type',
            moduleStateSlotName: 'default-geo-sections-geomasstype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
